import React from "react";
import Header from "../../components/Header";
import BlogList from "components/Blogs/BlogList";

import { listBlogs } from "actions/blog";
import { connect } from "react-redux";
import { getBlogList } from "selectors/blog";

const BlogListPage = ({ listBlogs, blogList }) => {
  const { isFetching, isFetched, listData } = blogList;

  return (
    <div>
      <Header></Header>
      <div className="container mx-auto">
        <div className="mt-20">
          {isFetched && (
            <BlogList blogs={blogList.listData.data} />
          )}
        </div>
      </div>
    </div>
  );
};

BlogListPage.getInitialProps = async ({ store }) => {
  await listBlogs(store.dispatch);
};

const mapStateToProps = (state) => ({
  blogList: getBlogList(state),
});

const mapDispatchToProps = {
  listBlogs,
};

export default connect(mapStateToProps, mapDispatchToProps)(BlogListPage);
